import React, { useContext, useState } from "react";
import { Modal, Fade, Box, Backdrop, Typography, Grid, TextField, Button } from "@mui/material";
import { CrearUnidad } from "../../../../../hooks/crearUnidad";
import { ThemeContext } from "@emotion/react";
import swal from 'sweetalert2'
import { CreateDefectivo } from "../../../../../hooks/defectivos";
import { useSnackbar } from "notistack";


export const ModalDefectivo = ({ open, setOpen, update_list }) => {

  const style = {
    position: 'absolute',
    top: '35%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    justifyContent: 'center'
  };

  const theme = useContext(ThemeContext)

  const { crearDefectivoMutation } = CreateDefectivo();
  const { enqueueSnackbar } = useSnackbar();
  const [errorArea, setErrorArea] = useState(false);
  const [errorDef, setErrorDef] = useState(false);

  const onSubmit = (event) => {
    event.preventDefault()
    if (
      event.target.def_area.value !== '' &&
      event.target.def_defecto.value !== ''
    ) {
      let data = {
        def_area: event.target.def_area.value,
        def_codigo: event.target.def_codigo.value,
        def_defecto: event.target.def_defecto.value
      }
      crearDefectivoMutation(data, {
        onSuccess: (data) => {
          handleClose();
          update_list();
          enqueueSnackbar(data?.mensaje, {
            autoHideDuration: 2000,
            variant: data?.success ? "success" : "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          });
        },
        onError: (error) => {
          enqueueSnackbar("Hubo un error al crear defectivo", {
            autoHideDuration: 2000,
            variant: "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          })
          update_list();
          handleClose();
        }
      })
    } else {
      if (event.target.def_area.value === '') setErrorArea(true)
      if (event.target.def_defecto.value === '') setErrorDef(true)
    }
  };

  const handleClose = () => setOpen(false);




  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <form onSubmit={onSubmit}>
            <Grid container spacing={0}>
              <Grid item xs={12} sx={{ p: 0, mb: 1, pr: 1 }} className="center_item">
                <Typography id="transition-modal-title" variant="h6" component="h2">
                  Nuevo Defectivo
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{ p: 0, mb: 1, pr: 1 }} >
                <TextField
                  id="def_area"
                  label="Área"
                  name="def_area"
                  size="small"
                  onChange={(e) => {
                    e.target.value.length > 0 ?
                      setErrorArea(false) :
                      setErrorArea(true)
                  }}
                  error={errorArea}
                  helperText={errorArea ? 'Ingrese un valor' : ''}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{ p: 0, mb: 1, pr: 1 }} >
                <TextField
                  id="def_codigo"
                  label="Código"
                  name="def_codigo"
                  fullWidth
                  size="small"
                  sx={{ color: theme.palette.primary.input }}
                />
              </Grid>
              <Grid item xs={12} sx={{ p: 0, mb: 1, pr: 1, mt: 2 }} >
                <TextField
                  id="def_defecto"
                  label="Descripción defectivo"
                  name="def_defecto"
                  fullWidth
                  size="small"
                  multiline
                  rows={2}
                  sx={{ color: theme.palette.primary.input }}
                  onChange={(e) => {
                    e.target.value.length > 0 ?
                      setErrorDef(false) :
                      setErrorDef(true)
                  }}
                  error={errorDef}
                  helperText={errorDef ? 'Ingrese un valor' : ''}
                />
              </Grid>
              <Grid item xs={12} sx={{ p: 0, mb: 1, pr: 1, mt: 2 }} >
                <Button variant="contained"
                  className="btn_system"
                  type="submit"
                >
                  Crear Defectivo
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Fade>
    </Modal>
  )
}